export default "__VITE_ASSET__2a4534ec__"